"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const ckeditor_1 = __importDefault(require("ckeditor5-custom/build/ckeditor"));
require("ckeditor5-custom/build/translations/zh-cn");
require("ckeditor5-custom/build/translations/en");
require("ckeditor5-custom/build/translations/ja");
const ckeditor5_react_1 = require("@ckeditor/ckeditor5-react");
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const detect_utils_1 = require("@/common/detect_utils");
const functions_1 = require("@/common/functions");
const errors_1 = require("@/common/errors");
const material_ui_confirm_1 = require("material-ui-confirm");
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1({ editorRef }) {
    const roomId = (0, react_redux_1.useSelector)((state) => state.roomData.id);
    const contentsData = (0, react_redux_1.useSelector)((state) => state.roomData.contents);
    const contentsLength = contentsData.length;
    const { t } = (0, react_i18next_1.useTranslation)();
    const localeObj = {
        ko: 'ko',
        zh_hans: 'zh-cn',
        en: 'en',
        ja: 'ja',
    };
    const currentLang = localeObj[(0, detect_utils_1.currentLanguage)()];
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const postContentsImage = (compressedImg, resolve, reject) => __awaiter(this, void 0, void 0, function* () {
        const formData = new FormData();
        formData.append('upload', compressedImg);
        yield (0, api_1.postFormData)(`/api/v1/store/room/${roomId}/detail-image`, formData)
            .then(res => resolve({ default: (0, functions_1.getCdnUrl)(res.data.url) }))
            .catch(err => {
            var _a, _b, _c, _d;
            const errorStatus = (_a = err.response) === null || _a === void 0 ? void 0 : _a.status;
            const errorCode = (_d = (_c = (_b = err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.alert_type;
            if (errorStatus === 400) {
                confirm({
                    description: t('앗 이미지 업로드를 실패했어요. 잠시 뒤에 시도해주세요.'),
                    cancellationButtonProps: { style: { display: 'none' } },
                });
            }
            else
                (0, errors_1.commonErrorConfirm)({ confirm, errorCode: errorCode || errorStatus });
            reject();
        });
    });
    function uploadAdapter(loader) {
        return {
            upload: () => {
                return new Promise((resolve, reject) => {
                    loader.file.then((imageFile) => {
                        (0, functions_1.compressImageFile)({
                            imageFile,
                            maxWidth: 1500,
                            quality: imageFile.size > 5000000 ? 0.5 : 0.8,
                            onCompressSuccess: compressed => postContentsImage(compressed, resolve, reject),
                            onCompressError: reject,
                        });
                    });
                });
            },
        };
    }
    function uploadPlugin(editor) {
        editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
            return uploadAdapter(loader);
        };
    }
    const customColorPalette = [
        {
            color: 'hsl(240, 3%, 11%)',
            label: '',
        },
        {
            color: 'hsl(0, 100%, 59%)',
            label: '',
        },
        {
            color: 'hsl(35, 100%, 50%)',
            label: '',
        },
        {
            color: 'hsl(48, 100%, 50%)',
            label: '',
        },
        {
            color: 'hsl(135, 59%, 49%)',
            label: '',
        },
        {
            color: 'hsl(177, 100%, 39%)',
            label: '',
        },
        {
            color: 'hsl(240, 1%, 29%)',
            label: '',
        },
        {
            color: 'hsl(199, 94%, 67%)',
            label: '',
        },
        {
            color: 'hsl(211, 100%, 50%)',
            label: '',
        },
        {
            color: 'hsl(241, 61%, 59%)',
            label: '',
        },
        {
            color: 'hsl(280, 68%, 60%)',
            label: '',
        },
        {
            color: 'hsl(16, 27%, 50%)',
            label: '',
        },
        {
            color: 'hsl(240, 2%, 57%)',
            label: '',
        },
        {
            color: 'hsl(177, 100%, 75%)',
            label: '',
        },
        {
            color: 'hsl(69, 100%, 50%)',
            label: '',
        },
        {
            color: 'hsl(60, 100%, 50%)',
            label: '',
        },
        {
            color: 'hsl(131, 100%, 60%)',
            label: '',
        },
        {
            color: 'hsl(165, 100%, 50%)',
            label: '',
        },
        {
            color: 'hsl(240, 24%, 96%)',
            label: '',
        },
        {
            color: 'hsl(180, 100%, 89%)',
            label: '',
        },
        {
            color: 'hsl(68, 100%, 79%)',
            label: '',
        },
        {
            color: 'hsl(49, 49%, 93%)',
            label: '',
        },
        {
            color: 'hsl(141, 100%, 89%)',
            label: '',
        },
        {
            color: 'hsl(0, 0%, 100%)',
            label: '',
            hasBorder: true,
        },
    ];
    const editorConfig = {
        extraPlugins: [uploadPlugin],
        removePlugins: ['MediaEmbedToolbar'],
        language: currentLang,
        fontColor: { colors: customColorPalette },
        fontBackgroundColor: { colors: customColorPalette },
        image: {
            upload: { types: ['jpeg', 'png', 'gif', 'bmp', 'webp'] },
            resizeOptions: [
                {
                    name: 'resizeImage:50',
                    value: '50',
                    icon: 'medium',
                },
                {
                    name: 'resizeImage:75',
                    value: '75',
                    icon: 'large',
                },
                {
                    name: 'resizeImage:100',
                    value: '100',
                    icon: 'original',
                },
            ],
            toolbar: [
                'toggleImageCaption',
                '|',
                'imageStyle:alignBlockLeft',
                'imageStyle:block',
                'imageStyle:alignBlockRight',
                '|',
                'resizeImage:50',
                'resizeImage:75',
                'resizeImage:100',
                '|',
                'linkImage',
            ],
        },
        table: {
            tableProperties: {
                borderColors: customColorPalette,
                backgroundColors: customColorPalette,
            },
            tableCellProperties: {
                borderColors: customColorPalette,
                backgroundColors: customColorPalette,
            },
        },
        toolbar: {
            items: [
                'fontColor',
                'fontBackgroundColor',
                'fontSize',
                '|',
                'bold',
                'italic',
                'underline',
                'strikethrough',
                '|',
                'alignment:left',
                'alignment:center',
                'alignment:right',
                '|',
                'link',
                'imageUpload',
                'mediaEmbed',
                '|',
                'insertTable',
                '|',
                'undo',
                'removeFormat',
                'redo',
            ],
            shouldNotGroupWhenFull: true,
        },
        fontSize: {
            options: [12, 14, 16, 18, 20, 22, 24],
        },
        mediaEmbed: {
            previewsInData: true,
        },
        placeholder: `-${t('실제 사진(다양한 각도)')}\r\n-${t('사이즈, 색상 등')}`,
    };
    const dispatch = (0, react_redux_1.useDispatch)();
    return ((0, jsx_runtime_1.jsxs)(ContentsEditorWrapper, { children: [Boolean(roomId) && ((0, jsx_runtime_1.jsx)(ckeditor5_react_1.CKEditor, { id: `contents_editor_${currentLang}`, editor: ckeditor_1.default, config: editorConfig, data: contentsData, onReady: (editor) => {
                    editorRef.current = editor;
                }, onChange: (_, editor) => {
                    const data = editor.getData();
                    const dataLength = data.length;
                    if (dataLength > 16500) {
                        editor.execute('undo');
                    }
                    else {
                        dispatch((0, roomCreateStore_1.setContents)(data));
                    }
                } })), (0, jsx_runtime_1.jsx)("span", Object.assign({ id: "ck_contents_counter" }, { children: `${contentsLength}/16,500자` }))] }));
}
exports.default = default_1;
const ContentsEditorWrapper = styled_1.default.div `
  position: relative;
  width: 100%;
  overflow-x: hidden;
  .ck-focused {
    border: 1px solid var(--gray-60) !important;
    box-shadow: none !important;
  }
  .ck-editor__main {
    height: 70vh;
  }
  .ck-content {
    p {
      margin-bottom: 8px;
      font-size: 16px;
      line-height: 1.5;
      * {
        line-height: 1.5;
      }
    }
    height: 100%;
    font-size: 16px;
  }
  .ck.ck-toolbar > .ck-toolbar__items > :not(.ck-toolbar__line-break) {
    margin-right: 1px;
  }
  .ck.ck-sticky-panel .ck-sticky-panel__content_sticky {
    position: relative;
    top: 0 !important;
    z-index: 10000 !important;
  }
  @media (max-width: 480px) {
    .ck-widget__resizer__handle {
      display: none;
    }
  }
  #ck_contents_counter {
    position: absolute;
    bottom: 10px;
    right: 20px;
    color: rgba(0, 0, 0, 0.2);
    font-size: 14px;
    z-index: 1;
    pointer-events: none;
  }

  .ck.ck-editor__editable > .ck-placeholder::before {
    white-space: pre-wrap;
    font-size: 15px;
    color: rgba(0, 0, 0, 0.3);
  }

  --ck-color-button-on-color: black;
  --ck-color-list-button-on-text: black;
  --ck-color-button-on-background: #dedede;
  --ck-color-list-button-on-background: #dedede;
  --ck-color-button-on-hover-background: #c4c4c4;
  --ck-color-list-button-on-background-focus: #c4c4c4;
  --ck-focus-ring: 1px solid rgba(0, 0, 0, 0.3);
  --ck-focus-outer-shadow: none;
  --ck-border-radius: 8px;
`;
